import * as z from "zod";

export const redeemReclaimPartnerCode = {
  name: "redeemReclaimPartnerCode" as const,
  input: z.object({ code: z.string().min(1).max(64) }),
  output: z.object({
    status: z.enum(["redeemed", "already_redeemed", "unavailable"]),
    partnerName: z.string().optional(),
    profileImageUrl: z.string().url().nullable().optional(),
    referralCode: z.string().optional(),
  }),
};
